module.exports = __webpack_public_path__ + "img/tentacle.a4953bbb.jpg";